export default {
  computed: {
    senderName () {
      return this.$store.state.header?.headerData?.companyName ?? null
    }
  }
}
